import { memo } from 'react';

import styles from './FooterInfoBlock.module.css';

import type { FC, HTMLAttributes, ReactChild } from 'react';

export interface FooterInfoBlockProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  title: string;
  children?: ReactChild;
}

const FooterInfoBlock: FC<FooterInfoBlockProps> = (props) => {
  const { title, children, ...restProps } = props;

  return (
    <div {...restProps}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
      </div>

      {children}
    </div>
  );
};

export default memo(FooterInfoBlock);
